import { useEffect, useState } from 'react';
import { Badge, BadgeSizeLG, BadgeTypes } from '@picsart/design-system/components/Badge';

import { TemplateContainer, TryButton } from '@picsart/growth-rc/Template';
import buildSlugFromNameAndId from 'utils/buildSlugFromNameAndId';
import addAnalyticsParamsToUrl from 'utils/addAnalyticsParamsToUrl';
import { getSingleTemplate } from 'templates/api';
import Image from 'components/Image';
import useStyles from './styles';
import { TemplateProps } from './types';
import { EditText } from '../constants';

export default function Template({ template, index, ...rest }: TemplateProps) {
  const classes = useStyles();

  const { display_name, url, is_paid, id, _id } = template;
  const templateId = id || _id;
  const [singleTemplateCategory, setSingleTemplateCategory] = useState(null);

  useEffect(() => {
    getSingleTemplate(String(templateId))
      .then(({ templateData }) => {
        setSingleTemplateCategory(templateData?.subtypes[0]);
      })
      .catch(error => {
        console.error('Error loading template:', error);
      });
  }, [templateId]);

  const formattedCategory = singleTemplateCategory
    ? encodeURI(singleTemplateCategory.replace(/-/g, '+'))
    : '';

  const redirectTemplatePageUrl = `/template/${buildSlugFromNameAndId({ id, name: display_name })}`;
  const redirectEditorPageUrl = addAnalyticsParamsToUrl(
    `/create/editor?template=${templateId}&category=templates${
      formattedCategory && `&templateSearch=${formattedCategory}`
    }`,
    {
      source: 'try-it-out-button',
      origin: 'templates',
    },
  );

  return (
    <TemplateContainer
      template={template}
      buttonLabel="Try it out"
      buttonLink={redirectEditorPageUrl}
    >
      <div className={index === 0 && classes.wrapper} {...rest}>
        <a
          href={redirectTemplatePageUrl}
          target="_blank"
          aria-label={`Edit template "${display_name}"`}
          className={classes.imgContainer}
          data-pulse-name={EditText}
          rel="noreferrer"
        >
          <Image src={url} alt={`Template "${display_name}"`} imageClassName={classes.img} />
          <div className={classes.btnContainer}>
            <TryButton />
          </div>
          {is_paid && (
            <Badge className={classes.badge} variant={BadgeTypes.Plus} size={BadgeSizeLG} />
          )}
        </a>
      </div>
    </TemplateContainer>
  );
}
